// @flow
import * as TrackingApi from 'Tracking/tracking-api';
import { difference } from 'lodash';

const findLegalInformation = (ref, legalInformations) =>
  legalInformations && legalInformations.find(({ ref: legalInfoRef }) => legalInfoRef === ref);

export const getLegalInformationTitle = (ref: string, legalInformations: *) =>
  (findLegalInformation(ref, legalInformations) || {}).title || ref;

export const trackForYouClub = (context: AppContext) => {
  TrackingApi.setDataLayer(
    {
      event: 'eventGA',
      categoryGA: 'PLE',
      actionGA: 'CTA_optin_foryouclub',
      labelGA: 'profilePage',
    },
    context,
  );
};

const CLUBMED = 'CLUBMED';
const PARTNERS = 'PARTNERS';
const FOSUN_PARTNERS = 'FOSUN_PARTNERS';
const FORYOUCLUB = 'FORYOUCLUB';

export function onCheckboxChange(
  checkbox: { name: string, checked: boolean },
  setFieldValue: (string, boolean) => void,
) {
  const fields = {
    [CLUBMED]: {
      checked: [CLUBMED],
      unchecked: [CLUBMED, PARTNERS],
    },
    [PARTNERS]: {
      checked: [CLUBMED, PARTNERS],
      unchecked: [PARTNERS],
    },
    [FOSUN_PARTNERS]: {
      checked: [FOSUN_PARTNERS],
      unchecked: [FOSUN_PARTNERS],
    },
    [FORYOUCLUB]: {
      checked: [FORYOUCLUB],
      unchecked: [FORYOUCLUB],
    },
  };

  if (checkbox.checked) {
    difference(fields[checkbox.name].checked, [checkbox.name]).map(id => setFieldValue(id, true));
  } else {
    difference(fields[checkbox.name].unchecked, [checkbox.name]).map(id =>
      setFieldValue(id, false),
    );
  }
}
